import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(params) {
    const factoryId = store.state.app.factory.id;
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'common_choice_group',
      params,
    });
    return res;
  },
  async show(choiceGroupId) {
    const res = await base.show({
      modelName: 'common_choice_group',
      modelId: choiceGroupId,
    });
    return res;
  },
  async create(data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'common_choice_group',
      data: _data,
    });
    return res;
  },
  async delete(choiceGroupId) {
    const res = await base.delete({
      modelName: 'common_choice_group',
      modelId: choiceGroupId,
    });
    return res;
  },
  async copy(choiceGroupId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'common_choice_group',
      parentId: choiceGroupId,
      modelName: 'copy',
      data: _data,
    });
    return res;
  },
  async update(choiceGroupId, data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.update({
      modelName: 'common_choice_group',
      modelId: choiceGroupId,
      data: _data,
    });
    return res;
  },
}